import { useNarrativeValuationOptions } from '../../../hooks/useNarrativeValuationOptions';
import { useMemo } from 'react';
import { NARRATIVE_FV_MODAL_COMMUNITY_NARRATIVES_LIMIT } from '../../../utils';
import { useUserProfile } from '@/hooks/useUserProfile';

type Props = {
  companyId: string;
};

export const useValuationSelectionFormData = ({ companyId }: Props) => {
  const { publicId } = useUserProfile();
  const { data: valuationOptionsData } = useNarrativeValuationOptions({
    companyId: companyId.toLowerCase(),
    communityLimit: NARRATIVE_FV_MODAL_COMMUNITY_NARRATIVES_LIMIT,
  });

  return useMemo(() => {
    const { company } = valuationOptionsData ?? {};
    const { valuationOptions, tickerSymbol } = company ?? {};

    const myNarrative =
      valuationOptions?.find(
        (option) =>
          option.type === 'USER_DEFINED' &&
          publicId &&
          option.narrative?.owner?.publicId === publicId
      )?.narrative ?? null;

    return {
      valuationOptions,
      tickerSymbol,
      myNarrative,
    };
  }, [valuationOptionsData, publicId]);
};
